import { render, staticRenderFns } from "./RightSection.vue?vue&type=template&id=26920a6e&scoped=true"
import script from "./RightSection.vue?vue&type=script&lang=js"
export * from "./RightSection.vue?vue&type=script&lang=js"
import style0 from "./RightSection.vue?vue&type=style&index=0&id=26920a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26920a6e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiProcessingSpinner: require('/usr/src/app/components/ui/ProcessingSpinner.vue').default})
